import React from 'react';
import links from 'utils/links';
import { Link } from 'react-router-dom';

/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    border: '2px solid #808080',
    borderRadius: '50%',
  },
  avatar: {
    margin: 3,
  },
  bigAvatar: {
    width: '100px',
    height: '100px',
    backgroundColor: '#d5d5d54a',
  },
  member_name: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: '#843384cf',
  },
  infoContent: {
    wordBreak: 'break-word',
  },
  careerCard: {
    marginTop: theme.spacing.unit * 2 + 4,
    marginRight: theme.spacing.unit * 2 + 4,
    marginBottom: theme.spacing.unit * 2 + 4,
    marginLeft: theme.spacing.unit * 2 + 4,
  },
  foodies: {
    textAlign: 'center',
    padding: '50px 20px 20px 20px',
    // background: theme.palette.ternary.dark,
    color: '#ffff',
    height: '300px',
    // background:'url("/img/HP Contributors.jpg")'
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    background:
      'linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.9)),url("/img/HP_Contributors.jpg")',
  },
  whiteText: {
    color: 'white',
  },
  contributeButton: {
    background: theme.palette.ternary.dark,
    color: '#ffff',
  },
  container: {
    padding: '10px',
  },
  principleContainer: {
    background: theme.palette.others.bg1,
  },
  memberContainer: {
    paddingBottom: '20px',
  },
  pageTitles: {
    padding: '20px 0 20px 0',
  },
});

const principles = [
  {
    name:
      'I love to discover and be part of food experiences that are delightful. ',
    content: [
      ` > You are here because you love exploring cultures through food.`,
      ` > You are here because you like the thought of being part of a community of foodies sharing their cherished food adventures.`,
    ],
  },
  {
    name: 'My opinion is unbiased as the eatery did not pay for my meal.',
    content: [
      ` > Your views on the eatery or the experience should be independent of any baises that are likely to creep in if the meal is not paid for, or is in lieu of favours.`,
      ` > A meal at a restaurant should be paid for either by you or someone in your group who is independent any influence from the establishment`,
    ],
  },
  {
    name: 'I only recommend restaurants that I have tried and loved.',
    content: [
      `> Tell the community about restaurants that you absolutely love or have been to again and again.`,
      `> This may be only about 20% or even less of the total options available in most cities, but that's okay because we believe in recommending only the most-loved on TS.`,
    ],
  },
  {
    name:
      'Food is a personal experience. I respect other opinions and welcome different perspectives.',
    content: [
      `> Where's the fun without differences in opinion. Enjoy it, respect it`,
      `> Someone disagrees with you? That's their opinion. You have yours.`,
    ],
  },
  {
    name: 'The experiences I share are mine and not borrowed.',
    content: [
      `> Authentic experiences will always stand out and be appreciated.`,
      `> Your words are far better than any you can borrow.`,
      `> Write what you want to share and not what you think others want to hear.`,
    ],
  },
  {
    name:
      'I recommend foodies whose opinions and independence I personally trust.',
    content: [
      `> Build the Pundit community by bringing together like minded people.`,
      `> Only refer people whom you consider an expert on food and cuisine. We trust your opinion.`,
    ],
  },
];

const howToBecomePundits = [
  {
    id: 1,
    step: 'You are the Wikipedia on eateries, cuisines and dishes to try out.',
  },
  {
    id: 2,
    step: 'Your friends swear by your food recommendations.',
  },
  {
    id: 3,
    step:
      'For cities that matter, you have a must-eat list of dishes every time you visit.',
  },
  {
    id: 4,
    step:
      'Travelling is more about the variety of food up for experiencing, than sightseeing.',
  },
];

const MemberCard = props => {
  const { classes, name, img, id } = props; // linkTitle
  return (
    <Grid item xs={6} className={classes.memberContainer}>
      <div className={classes.imageContainer}>
        <div className={classes.row}>
          <Link to={links.contributorProfileLinks(id)}>
            <Avatar
              alt={name}
              src={img}
              className={classNames(classes.avatar, classes.bigAvatar)}
            />
          </Link>
        </div>
        <Typography
          className={classes.member_name}
          component="h3"
          variant="body1"
        >
          <b>{name}</b>
        </Typography>
        <Link to={links.contributorProfileLinks(id)}>
          <Button variant="contained" className={classes.contributeButton}>
            View Profile
          </Button>
        </Link>
      </div>
    </Grid>
  );
};

const Principle = ({ number, name, content, classes }) => {
  return (
    <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body1">
          <b>
            Principle #{number}: {name}
          </b>
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.principleContainer}>
        <div>
          {typeof content === 'object' ? (
            content.map((sub, id) => {
              return (
                <Typography variant="body1" key={id}>
                  {sub}
                </Typography>
              );
            })
          ) : (
            <Typography variant="body1">{content}</Typography>
          )}
        </div>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

class Community extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentDidMount() {
    this.props.dispatch(actions.getData());
  }
  render() {
    const { classes, loading, contributors } = this.props; // history
    const filterTopContributor = contributors.filter(function(datas) {
      return datas.profilePic !== null;
    });
    if (loading) {
      return <Loader />;
    } else {
      return (
        <div>
          <div className={classes.foodies}>
            <Typography
              className={classes.whiteText}
              variant="h5"
              component="h5"
            >
              Our Community
            </Typography>
            <br />
            <Typography variant="body1" className={classes.whiteText}>
              <i>
                Our community is built on the common obsession for delightful
                food. Our Pundits are experts on restaurants, dishes, cuisines,
                and experiences, coming together to share their insights and
                knowledge.
              </i>
            </Typography>
          </div>
          <Grid container>
            <Grid item xs={12} style={{ padding: '10px' }}>
              <br />
              <Typography variant="h6">Who is a TS Food Pundit?</Typography>
              <br />
              <Typography variant="body1">
                Talking Street is a platform for foodies, by foodies. We exist
                because people who love food, across cities, shared their
                insider knowledge of the best food in their cities. They opened
                up their hearts and told us which eateries must make it to the
                Talking Street recommended list. Some even went out of their way
                to host us, give us lists of eateries to visit or painstakingly
                edit the lists we sent them. We are so thankful for the many,
                many passionate foodies who embrace what we are attempting to
                build and contribute so meaningfully.
              </Typography>
              <br />
              <Typography variant="body1">
                To put it simply, our Pundits can be recognized by the following
                characteristics. [Can also be read as Selection Criteria, if
                that helps :-) ]
              </Typography>
              <br />
              <Typography variant="body1">
                1. An obsessive passion about food.[Goes without saying.]
              </Typography>
              <Typography variant="body1">
                2. High standards of Integrity.[Perhaps as important than 1.]
              </Typography>
              <Typography variant="body1">
                3. Independent Opinion.[Unbiased by gifts in cash or kind.]
              </Typography>
              <Typography variant="body1">
                4. Original Stories.[First hand, fresh.]
              </Typography>
              <br />
              <br />
              <Typography variant="h6">
                How to become a TS Food Pundit?
              </Typography>
              <br />
              <Typography variant="body1">
                Foodies are at the heart of Talking Street and we’re on a
                journey to cover more and more cities across the world, one
                dish, one eatery at a time. if the description below sounds like
                you, write in!
              </Typography>
              <List dense className={classes.root}>
                {howToBecomePundits.map((value, id) => (
                  <ListItem key={id} button>
                    <ListItemText
                      style={{ fontSize: '1.089375rem' }}
                      primary={`${value.id}. ${value.step}`}
                    />
                  </ListItem>
                ))}
              </List>
              <br />
              <Typography variant="body1">
                If those are the contours of your relationship with food, you
                sounds like a Food Pundit Talking Street's foodies would love to
                hear from. Please fill up this short form telling us a little
                more about your affection for food, which city you’re from and
                why you believe in what we’re trying to do.
              </Typography>
              <br />
              <Typography variant="h6">Selection process</Typography>
              <br />
              <Typography variant="body1">
                What we absolutely adore about our Pundits is the absence of
                bias in any form, and our readers love that about the
                recommendations on Talking Street. So apart from the above
                criteria, we look for Pundits who vibe with our philosophy and
                ethos.
              </Typography>
            </Grid>
          </Grid>
          {/* <div style={{ textAlign: 'center' }}>
            <Button variant="contained" className={classes.contributeButton}>
              Become a contributor
            </Button>
          </div> */}
          <Grid container className={classes.container}>
            <Grid item xs={12}>
              <Typography className={classes.pageTitles} variant="h6">
                Our Manifesto
              </Typography>
            </Grid>
          </Grid>
          <div>
            {principles.map((principle, i) => (
              <Principle
                classes={classes}
                key={'principle' + i}
                number={i + 1}
                name={principle.name}
                content={principle.content}
              />
            ))}
          </div>

          <Grid container className={classes.container}>
            <br />
            <br />
            <Typography className={classes.pageTitles} variant="h6">
              {/* Recent contributors */}
              Food Pundits
            </Typography>
            <br />
            <br />
            {/* <Grid container>
              {contributors.map((contributor, i) => (
                <MemberCard
                  key={'contributor' + i}
                  name={contributor.firstName + ' ' + contributor.lastName}
                  img={contributor.profilePic}
                  linkTitle={contributor.linkTitle}
                  classes={classes}
                />
              ))}
            </Grid> */}
            {/* ------ Temporary  ---------*/}
            <Grid container>
              {filterTopContributor.map((contributor, i) => (
                <MemberCard
                  key={'contributor' + i}
                  name={contributor.displayName}
                  img={
                    contributor.profilePic
                      ? contributor.profilePic.uri
                      : '/icons/user.png'
                  }
                  linkTitle={contributor.linkTitle}
                  classes={classes}
                  id={contributor.id}
                />
              ))}
            </Grid>
            {/* ------ Temporary  ---------*/}
          </Grid>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(Community));
